import api from './api';

interface Task {
    id: number;
    name: string;
    function: number;
    description: string;
    created_at: string;
    updated_at: string;
}

interface CreateTaskData {
    name: string;
    function: number;
    description?: string;
}

export const listTasks = async (functionId?: number): Promise<Task[]> => {
    const params = new URLSearchParams();
    if (functionId) {
        params.append('function', functionId.toString());
    }

    const response = await api.get(`tasks/?${params.toString()}`);
    return response.data;
};

export const createTask = async (data: CreateTaskData): Promise<Task> => {
    const response = await api.post(`tasks/`, data);
    return response.data;
};

export const updateTask = async (id: number, data: Partial<CreateTaskData>): Promise<Task> => {
    const response = await api.patch(`tasks/${id}/`, data);
    return response.data;
};

export const deleteTask = async (id: number): Promise<void> => {
    await api.delete(`tasks/${id}/`);
};